import React, { useEffect, useState, useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useHistory,
} from "react-router-dom";
import MainPage from "./Pages/MainPage";
import SkinCare from "./Pages/Categories/SkinCare";
import MakeUp from "./Pages/Categories/MakeUp";
import Brands from "./Pages/MainPageComponents.js/Brands";
import Loreal from "./Pages/Brands.js/Loreal";
import Header1 from "./Pages/Header1";
import Header2 from "./Pages/Header2";
import "bootstrap/dist/css/bootstrap.min.css";
import ScrollToTopButton from "./Pages/ScrollToTopButton";
import BottomBlock from "./Pages/BottomBlock";
import AboutUs from "./Pages/AboutUs";
import ProductDisc from "./Pages/ProductDisc";
import Categories from "./Pages/MainPageComponents.js/Categories";
import AllCategories from "./Pages/AllCategories";
import CheckOut from "./Pages/CheckOut";
import Register from "./Pages/Register";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Try from "./Pages/Try";
import Profile from "./Pages/Profile";
import AddProduct from "./AddProduct";
import axios from "axios";
import ProfileWishList from "./Pages/ProfileComponents/ProfileWishList";
import News from "./Pages/News";
import NewsCategory from "./Pages/NewsCategory";
import Brand from "./Pages/Brand";
import BrandPage from "./Pages/BrandPage";
import SimilarProductsComp from "./Pages/ProductDiscComponents/SimilarProductsComp";
import FeedBack from "./Pages/FeedBack";
import Delivery from "./Pages/Delivery";
import SpecialOffers from "./Pages/SpecialOffers";
import Articles from "./Pages/Articles";
import SearchPage from "./Pages/SearchPage";
import SubscriptionPage from "./Pages/SubscriptionPage";
import OrderDetials from "./Pages/OrderDetials";
import AuthGuard from "./AuthGuard";
import Unauthorized from "./Unauthorized";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import { useTranslation } from "react-i18next";

import "./i18n";
import BeautyClub from "./BeautyClub";
import AskChooseLang from "./AskChooseLang";

//export const MyDomain = "http://localhost:3000/";

//for local
//export const MyDomain = "https://localhost:44326/";
//for cloud
export const MyDomain =
  "https://makeup-csharp.happymushroom-066fb8ce.westeurope.azurecontainerapps.io/";

const App = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("en");
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const history = useHistory();

  useEffect(() => {
    changeLanguage(lang);
    const normalizedPath = window.location.pathname.toLowerCase();
    if (window.location.pathname !== normalizedPath) {
      history.replace(normalizedPath); // Redirect to lowercase URL
    }
  }, [history]);

  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const handleClearSpecificItem = () => {
  //   const keyToRemove = "wishList"; // Replace 'yourKey' with the key of the item you want to remove
  //   localStorage.removeItem(keyToRemove);
  //   console.log(`${keyToRemove} removed from localStorage`);
  // };

  return (
    <div
      style={{
        paddingLeft:
          windowWidth <= 1024
            ? "0%"
            : windowWidth <= 1920
            ? "5%"
            : windowWidth <= 2560
            ? "15%"
            : windowWidth <= 3840
            ? "20%"
            : "25%",
        paddingRight:
          windowWidth <= 1024
            ? "0%"
            : windowWidth <= 1920
            ? "5%"
            : windowWidth <= 2560
            ? "15%"
            : windowWidth <= 3840
            ? "20%"
            : "25%",
        justifyContent: "center",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <AskChooseLang />
      {/* Conditionally render Header1 based on the route */}
      {location.pathname !== "/checkout" && <Header1 />}
      {location.pathname !== "/checkout" && <Header2 />}
      {location.pathname !== "/checkout" && <Categories />}

      <Switch>
        {/* <Route exact path="/profile" component={Profile} /> */}
        {/* <Route exact path="/checkout" component={CheckOut} /> */}

        <Route exact path="/" component={MainPage} />
        <Route exact path="/main-page" component={MainPage} />
        <Route exact path="/SkinCare" component={SkinCare} />
        <Route exact path="/MakeUp" component={MakeUp} />
        <Route exact path="/Brands" component={Brands} />
        <Route exact path="/Loreal" component={Loreal} />
        <Route exact path="/about-us" component={AboutUs} />
        <Route exact path="/product/:ProductId" component={ProductDisc} />
        <Route exact path="/Register" component={Register} />
        <Route exact path="/profile/:profilecomp" component={Profile} />
        <Route exact path="/Try" component={Try} />
        <Route exact path="/AddProduct" component={AddProduct} />
        <Route exact path="/Delivery" component={Delivery} />
        <Route exact path="/actions" component={SpecialOffers} />
        <Route exact path="/articles" component={Articles} />
        <Route exact path="/search" component={SearchPage} />
        <Route exact path="/subscriptionpage" component={SubscriptionPage} />
        <Route exact path="/forgot-password" component={ForgotPasswordPage} />
        <Route exact path="/beauty-club" component={BeautyClub} />
        <Route exact path="/ask-choose-lang" component={AskChooseLang} />

        {/* <Route exact path="/orderd-details" component={OrderDetials} /> */}
        <Route exact path="/unauthorized" component={Unauthorized} />
        <Route
          path="/checkout"
          render={(props) => (
            <AuthGuard allowedRoles={["Client"]}>
              <CheckOut {...props} />
            </AuthGuard>
          )}
        />

        <Route
          path="/profile"
          render={(props) => (
            <AuthGuard allowedRoles={["Client"]}>
              <Profile {...props} />
            </AuthGuard>
          )}
        />
        <Route
          exact
          path="/orderd-details/:theorder"
          render={({ match }) => (
            <OrderDetials
              key={match.params.theorder}
              theorder={match.params.theorder}
            />
          )}
        />
        <Route
          exact
          path="/SimilarProductsComp"
          component={SimilarProductsComp}
        />
        {/* <Route
          exact
          path="/allcategories/:CategoryName"
          component={AllCategories}
        /> */}
        <Route
          exact
          path="/allcategories/:CategoryName"
          render={({ match }) => (
            <AllCategories
              key={match.params.CategoryName}
              CategoryName={match.params.CategoryName}
            />
          )}
        />
        <Route
          exact
          path="/News"
          component={News}
          // exact
          // path="/news/:CategoryName"
          // render={({ match }) => (
          //   <News
          //     key={match.params.CategoryName}
          //     CategoryName={match.params.CategoryName}
          //   />
          // )}
        />
        <Route
          exact
          //path="/News"
          component={NewsCategory}
          // exact
          path="/news/:CategoryName"
          render={({ match }) => (
            <News
              key={match.params.CategoryName}
              CategoryName={match.params.CategoryName}
            />
          )}
        />

        <Route exact path="/Brand" component={Brand} />
        <Route exact path="/FeedBack" component={FeedBack} />

        <Route
          exact
          //path="/News"
          component={BrandPage}
          // exact
          path="/Brand/:CategoryName"
          render={({ match }) => (
            <Brand
              key={match.params.CategoryName}
              CategoryName={match.params.CategoryName}
            />
          )}
        />
      </Switch>
      <ScrollToTopButton />

      {location.pathname !== "/checkout" && <BottomBlock />}
    </div>
  );
};

export default App;
